export const filterSearchInFields = ({ items, fields, query }) => {
  const normalizedQuery = normalizeString((query || '').trim());

  return (items || []).filter((item) => (fields || []).some((field) => {
    const normalizedField = normalizeString(_get(item, field) || '');

    return normalizedField.includes(normalizedQuery);
  }));
};
